import {
    FETCH_APPVERSION_SUCCESS_ACTION,
} from './action'

const initialState = {
    processing: false,
    error: false,
  }

export default function (state: any = initialState, action: Function) {
   
    switch (action.type) {
        case FETCH_APPVERSION_SUCCESS_ACTION:
         
            return {
                ...state,
                 appversionDtls: action.payload,
                
            }
        default:
            return {
                ...state
            }
    }

}